import { Component, OnInit } from '@angular/core';
import { UserActivityService } from './services/user-activity.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'front-fec';
  constructor(private userActivityService: UserActivityService) {}

  ngOnInit() {
    if (localStorage.getItem('sesionAsociado')) {
      this.userActivityService.startTracking();
    }
  }

}
